import { determineEngine, Engine } from './engine';

/**
 * @readonly
 * @enum {string}
 */
export const Platform = {
    ANDROID: 'android',
    IOS: 'ios',
};

/**
 * Returns the undelying platform of the currently runing {@link Engine}. If
 * said platform can't be determined, returns null
 * @return {Platform|null}
 */
export function determinePlatform() {
    const engine = determineEngine();
    if (engine === Engine.CORDOVA) {
        const platform = (window.device && window.device.platform || '').toLowerCase();
        if (platform === Platform.ANDROID || platform === Platform.IOS)
            return platform;
        else
            return null;
    } else if (engine === Engine.BROWSER) {
        if (/android/i.test(window.navigator.userAgent)) {
            return Platform.ANDROID;
        } else if (/iphone|ipad/i.test(window.navigator.userAgent)) {
            return Platform.IOS;
        } else {
            return null;
        }
    } else
        return null;
}



// WEBPACK FOOTER //
// ./src/shared/engine-dynamic/platform.js